const StorySection = () => {
  return (
    <section
      id="story"
      data-testid="story-section"
      className="py-24 md:py-32 bg-brand-bg-light"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="border border-brand-primary/10 p-2">
              <img
                src="https://images.unsplash.com/photo-1777726041709-7e2875bfa0e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxJbmRpYW4lMjBiYXNtYXRpJTIwcmljZSUyMGJpcnlhbmklMjBzYWZmcm9uJTIwbG9uZyUyMGdyYWluJTIwZmx1ZmZ5fGVufDB8fHx8MTc3ODQ2NDYwM3ww&ixlib=rb-4.1.0&q=85"
                alt="Fluffy Indian basmati rice"
                data-testid="story-image"
                className="w-full h-[400px] lg:h-[500px] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 border border-brand-gold/30" />
          </div>

          {/* Right: Text */}
          <div className="space-y-6">
            <p className="text-xs uppercase tracking-[0.3em] font-body font-semibold text-brand-gold">
              Our Heritage
            </p>
            <h2 className="font-heading text-3xl md:text-5xl font-light tracking-tight text-brand-primary">
              25 Years of
              <br />
              <span className="italic">Excellence</span>
            </h2>
            <div className="w-16 h-[1px] bg-brand-gold" />
            <p className="font-body text-base font-light leading-relaxed text-brand-text-dark/70">
              Born from a passion for perfection, Sartaj began 25 years ago with
              a simple promise: to bring the purest basmati rice to tables across
              the world. Every grain is carefully selected, naturally aged, and
              processed with techniques refined over decades of expertise.
            </p>
            <p className="font-body text-base font-light leading-relaxed text-brand-text-dark/70">
              Today, Sartaj is synonymous with excellence, proudly supplying leading
              food service operators, ready-to-eat meal manufacturers, restaurants,
              and discerning home cooks who recognise that exceptional meals begin
              with exceptional rice.
            </p>
            <div className="flex items-center gap-12 pt-6">
              <div>
                <span className="font-heading text-4xl text-brand-gold">25+</span>
                <p className="text-xs uppercase tracking-widest text-brand-text-dark/50 font-body mt-1">
                  Years of Legacy
                </p>
              </div>
              <div>
                <span className="font-heading text-4xl text-brand-gold">1</span>
                <p className="text-xs uppercase tracking-widest text-brand-text-dark/50 font-body mt-1">
                  Country Served
                </p>
              </div>
              <div>
                <span className="font-heading text-4xl text-brand-gold">6+</span>
                <p className="text-xs uppercase tracking-widest text-brand-text-dark/50 font-body mt-1">
                  Premium Varieties
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;
